import { usersApi } from 'entities/users';

type PutAvailableProductResponseDataType = {
  product_id: number | null;
};

const availableProductApi = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    updateAvailableProduct: builder.mutation<PutAvailableProductResponseDataType, any>({
      query: (body) => ({
        url: '/shop/admin/v1/available-product/update-available-product-by-id',
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const { useUpdateAvailableProductMutation } = availableProductApi;
